import { useCallback } from "react";
import { useAxiosInstances } from "../../axios-instance";
import { IListaCidades } from "../../../application/models";

export const useListaCidadesApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const createListaCidadesApi = useCallback(
    async (data: { Nome: string; IdUsuario: number }): Promise<IListaCidades> => {
      try {        
        const result = await axiosAuthInstance.post("/geo-veles/lista-cidade", {
          idUsuario: data.IdUsuario,
          nome: data.Nome,
        });
        return result.data.ListaCidade
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const findListaCidadesByIdApi = useCallback(
    async (data: { idVelesGeoListaCidades: number }): Promise<IListaCidades> => {
      try {
        const result = await axiosAuthInstance.get(
          `/geo-veles/lista-cidade/lista/${data.idVelesGeoListaCidades}`
        );

        return result.data.ListaCidade;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );


  const findListasCidadesApi = useCallback(
    async (data: { idCliente: number }): Promise<IListaCidades[]> => {
     
      try { 
        const result = await axiosAuthInstance.get(
          `/geo-veles/lista-cidade/${data.idCliente}`
        )
         return result.data.ListaCidade;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateListaCidadesApi = useCallback(
    async (data: {
      idVelesGeoListaCidade: number;
      idUsuario: number;
      cidade: string;
      nome: string;
    }): Promise<IListaCidades> => {
      try {
        const result = await axiosAuthInstance.put(
          "/geo-veles/lista-cidade/cidade",
          {
            idVelesGeoListaCidade: data.idVelesGeoListaCidade,
            idUsuario: data.idUsuario,
            cidade: data.cidade,
            nome: data.nome,
          }
        );

        return result.data.listaCidades;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateListaCidadesStatusApi = useCallback(
    async (data: {
      idVelesGeoListaCidade: number;
      idUsuario: number;
      ativa: boolean;
    }): Promise<IListaCidades> => {
      try {
        const result = await axiosAuthInstance.put(
          "/geo-veles/lista-cidade/cidade/status",
          {
            idVelesGeoListaCidade: data.idVelesGeoListaCidade,
            idUsuario: data.idUsuario,
            ativa: data.ativa,
          }
        );

        return result.data.listaCidades;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  return {
    createListaCidadesApi,
    findListaCidadesByIdApi,
    findListasCidadesApi,
    updateListaCidadesApi,
    updateListaCidadesStatusApi,
  };
};